import globalStyles from '../../styles/exported.module.scss';

type IconVariant = 'primary' | 'secondary';

export const MobileMenuIcon = ({ className, variant = 'primary' }: { variant?: IconVariant; className?: string }) => {
  const color = globalStyles[variant === 'primary' ? 'bdPureWhite' : 'bdPrimaryNavy'];

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...(className && { className })}
    >
      <path d="M3 12H21" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3 6H21" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3 18H21" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
